import React, { PureComponent } from 'react';
import { Cell, BodyRow } from '../../../RoTable';

import { TooltipProperties, LegendIcon } from '@ro-atoms/RoTooltip/RoTooltip.types';
import { SpIconWrapper } from '@ro-atoms/RoTooltip/RoTooltip.styles';
import Icon from '@ro-atoms/Icon';

interface Props {
  tooltipProps: TooltipProperties;
  legendUnitText: string;
  legendUnit: string;
  distance?:
    | {
        dbz: number;
        color: string;
      }
    | undefined;
  legendIcon: LegendIcon;
  pickerValue: {
    value: number;
    description: string;
  };
}

export class Radar extends PureComponent<Props> {
  render() {
    const { legendIcon, legendUnitText, pickerValue, distance, legendUnit } = this.props;
    return (
      <BodyRow>
        <Cell maxWidth={200}>
          <SpIconWrapper size={30} bg="#000" color={distance && distance.color}>
            <Icon weather={legendIcon.weather} name={legendIcon && legendIcon.name} />
          </SpIconWrapper>
          <b>{legendUnitText}</b>
        </Cell>
        <Cell maxWidth={200}>
          {!!pickerValue ? `${pickerValue.value.toFixed(2)} ${legendUnit}` : '-'}
          {!!pickerValue && pickerValue.description && ` (${pickerValue.description})`}
        </Cell>
      </BodyRow>
    );
  }
}
